import { Component } from "react";
import { AuditRequest, ClubEnrollment, PathType } from "../../../model";
import "./PathFormV6.scss";
import TopSportsBasicCriteriaPart from "./BasicCriteriaPart/TopSportsBasicCriteriaPart";
import YouthSportContentPart from "./SportContentPart/YouthSportContentPart";
import AdultsSportContentPart from "./SportContentPart/AdultsSportContentPart";
import TopSportsSportContentPart from "./SportContentPart/TopSportsSportContentPart";
import YouthManagementPart from "./ManagementPart/YouthManagementPart";
import AdultsManagementPart from "./ManagementPart/AdultsManagementPart";
import TopSportsManagementPart from "./ManagementPart/TopSportsManagementPart";
import YouthResourcesPart from "./ResourcesPart/YouthResourcesPart";
import AdultsResourcesPart from "./ResourcesPart/AdultsResourcesPart";
import TopSportsResourcesPart from "./ResourcesPart/TopSportsResourcesPart";
import YouthPeoplePart from "./PeoplePart/YouthPeoplePart";
import AdultsPeoplePart from "./PeoplePart/AdultsPeoplePart";
import TopSportsPeoplePart from "./PeoplePart/TopSportsPeoplePart";
import PathFormWrapper from "../PartFormWrapper";
import CommentModal from "../../../components/CommentModal/CommentModal";
import {
  translatedGradeOptions,
  translatedGradeRatingMap,
  translatedYesNoMap,
  translatedYesNoOptions,
} from "./model";
import { withTranslation, WithTranslation } from "react-i18next";
import { AttachmentAuditModal } from "../../AttachmentModal/AttachmentAuditModal";
import { AuditFormMetaInfo } from "../../../modules/formMetaInfo";
import { SportsFederationTranslationKeyMapType } from "../../../modules/config";

type PathFormV6Props = {
  currentOrg: number | null;
  enrollment: ClubEnrollment | null | undefined;
  activeRequest: AuditRequest | null | undefined;
  readOnlyMode: boolean;
  commentEdit: boolean;
  clubMode: boolean;
  formPart: string;
  pathType: string;
  formMetaInfo: AuditFormMetaInfo;
  sportsFederationTranslationKeyMap: SportsFederationTranslationKeyMapType | {};
};

class PathFormV6 extends Component<PathFormV6Props & WithTranslation, any> {
  render() {
    const {
      t,
      currentOrg,
      enrollment,
      activeRequest,
      readOnlyMode,
      commentEdit,
      clubMode,
      pathType,
      formPart,
      formMetaInfo,
      sportsFederationTranslationKeyMap,
    } = this.props;
    if (!currentOrg) {
      return null;
    }
    let formContent: any = null;

    const FORM_VERSION = 6;

    const formPartIsTopSportsBasicCriteria =
      formPart === "basiccriteria" && pathType === PathType.TOP_SPORTS;

    const options = formPartIsTopSportsBasicCriteria
      ? translatedYesNoOptions(t)
      : translatedGradeOptions(t);
    const ratingMap = formPartIsTopSportsBasicCriteria
      ? translatedYesNoMap(t)
      : translatedGradeRatingMap(t);

    switch (formPart) {
      case "basiccriteria":
        formContent =
          pathType === PathType.TOP_SPORTS ? (
            <PathFormWrapper
              form={`${pathType}basiccriteria`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="TOP_SPORTS"
              partKey="basiccriteria"
              toolsKey="topSportsBasiccriteria"
              translationNs="formsV6"
              formMetaInfo={formMetaInfo}
              formVersion={FORM_VERSION}
              sportsFederationTranslationKeyMap={
                sportsFederationTranslationKeyMap
              }
            >
              <TopSportsBasicCriteriaPart />
            </PathFormWrapper>
          ) : null;
        break;
      case "sportcontent":
        formContent =
          pathType === PathType.YOUTH ? (
            <PathFormWrapper
              form={`${pathType}sportcontent`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="YOUTH"
              partKey="sportcontent"
              toolsKey="youthSportcontent"
              translationNs="formsV6"
            >
              <YouthSportContentPart />
            </PathFormWrapper>
          ) : pathType === PathType.ADULTS ? (
            <PathFormWrapper
              form={`${pathType}sportcontent`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="ADULTS"
              partKey="sportcontent"
              toolsKey="adultsSportcontent"
              translationNs="formsV6"
            >
              <AdultsSportContentPart />
            </PathFormWrapper>
          ) : pathType === PathType.TOP_SPORTS ? (
            <PathFormWrapper
              form={`${pathType}sportcontent`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="TOP_SPORTS"
              partKey="sportcontent"
              toolsKey="topsportsSportcontent"
              translationNs="formsV6"
              formMetaInfo={formMetaInfo}
              formVersion={FORM_VERSION}
              sportsFederationTranslationKeyMap={
                sportsFederationTranslationKeyMap
              }
            >
              <TopSportsSportContentPart />
            </PathFormWrapper>
          ) : null;
        break;
      case "management":
        formContent =
          pathType === PathType.YOUTH ? (
            <PathFormWrapper
              form={`${pathType}management`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="YOUTH"
              partKey="management"
              toolsKey="youthManagement"
              translationNs="formsV6"
            >
              <YouthManagementPart />
            </PathFormWrapper>
          ) : pathType === PathType.ADULTS ? (
            <PathFormWrapper
              form={`${pathType}management`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="ADULTS"
              partKey="management"
              toolsKey="adultsManagement"
              translationNs="formsV6"
            >
              <AdultsManagementPart />
            </PathFormWrapper>
          ) : pathType === PathType.TOP_SPORTS ? (
            <PathFormWrapper
              form={`${pathType}management`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="TOP_SPORTS"
              partKey="management"
              toolsKey="topSportsManagement"
              translationNs="formsV6"
              formMetaInfo={formMetaInfo}
              formVersion={FORM_VERSION}
              sportsFederationTranslationKeyMap={
                sportsFederationTranslationKeyMap
              }
            >
              <TopSportsManagementPart />
            </PathFormWrapper>
          ) : null;
        break;
      case "resources":
        formContent =
          pathType === PathType.YOUTH ? (
            <PathFormWrapper
              form={`${pathType}resources`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="YOUTH"
              partKey="resources"
              toolsKey="youthResources"
              translationNs="formsV6"
            >
              <YouthResourcesPart />
            </PathFormWrapper>
          ) : pathType === PathType.ADULTS ? (
            <PathFormWrapper
              form={`${pathType}resources`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="ADULTS"
              partKey="resources"
              toolsKey="adultsResources"
              translationNs="formsV6"
            >
              <AdultsResourcesPart />
            </PathFormWrapper>
          ) : pathType === PathType.TOP_SPORTS ? (
            <PathFormWrapper
              form={`${pathType}resources`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="TOP_SPORTS"
              partKey="resources"
              toolsKey="topSportsResources"
              translationNs="formsV6"
              formMetaInfo={formMetaInfo}
              formVersion={FORM_VERSION}
              sportsFederationTranslationKeyMap={
                sportsFederationTranslationKeyMap
              }
            >
              <TopSportsResourcesPart />
            </PathFormWrapper>
          ) : null;
        break;
      case "people":
        formContent =
          pathType === PathType.YOUTH ? (
            <PathFormWrapper
              form={`${pathType}people`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="YOUTH"
              partKey="people"
              toolsKey="youthPeople"
              translationNs="formsV6"
            >
              <YouthPeoplePart />
            </PathFormWrapper>
          ) : pathType === PathType.ADULTS ? (
            <PathFormWrapper
              form={`${pathType}people`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="ADULTS"
              partKey="people"
              toolsKey="adultsPeople"
              translationNs="formsV6"
            >
              <AdultsPeoplePart />
            </PathFormWrapper>
          ) : pathType === PathType.TOP_SPORTS ? (
            <PathFormWrapper
              form={`${pathType}people`}
              commentEdit={commentEdit}
              orgId={currentOrg.toString()}
              auditRequest={activeRequest}
              enrollment={enrollment}
              clubMode={clubMode}
              readOnlyMode={readOnlyMode}
              pathType="TOP_SPORTS"
              partKey="people"
              toolsKey="topSportsPeople"
              translationNs="formsV6"
              formMetaInfo={formMetaInfo}
              formVersion={FORM_VERSION}
              sportsFederationTranslationKeyMap={
                sportsFederationTranslationKeyMap
              }
            >
              <TopSportsPeoplePart />
            </PathFormWrapper>
          ) : null;
        break;
      default:
        break;
    }
    return (
      <div className="pathformversionwrapper">
        <CommentModal ratingMap={ratingMap} options={options} />
        <AttachmentAuditModal />
        {formContent}
      </div>
    );
  }
}

export default withTranslation("formsV6")(PathFormV6);
